import { render } from "./Customer.vue?vue&type=template&id=effd949c&scoped=true&ts=true"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"

import "./Customer.vue?vue&type=style&index=0&id=effd949c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-effd949c"]])

export default __exports__